var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import { jsx as _jsx } from "react/jsx-runtime";
import styled from 'styled-components';
import SyfLoader from 'syf-component-library/ui/atoms/Loader/SyfLoader';
/*
 * Note: This fix uses position:absolute because we are missing display: flex on the modal content.
 * This is a feature of the component library to fix an issue in safari browsers.
 * This issue would have to be solved in the Syf-component-library in order for us to use display: flex and justify-content: center;
 */
var LoadingWrapper = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n"], ["\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n"])));
var Loading = function () { return (_jsx(LoadingWrapper, { children: _jsx(SyfLoader, { size: 4.375 }) })); };
export default Loading;
var templateObject_1;
//# sourceMappingURL=index.js.map